class TinkerTime extends HTMLElement {
  constructor() {
    super();
    this._isOpen = false;
  }

  get value() { return this.hiddenInput ? this.hiddenInput.value : ''; }
  set value(val) { this.selectTime(val); }

  connectedCallback() {
    setTimeout(() => {
        this.injectStyles();
        this.init();
        this.observeChanges();
    }, 0);
  }

  init() {
    this.initialValue = this.getAttribute('initial-value');
    this.name = this.getAttribute('name') || 'time';
    
    // Parse options from script tag if not already loaded
    try {
      const scriptTag = this.querySelector('script[type="application/json"]');
      if (scriptTag) {
        this.options = JSON.parse(scriptTag.textContent);
      } else if (!this.options) {
        this.options = [];
      }
    } catch (e) { this.options = []; }

    // Check if we are empty (theme wiped us)
    if (!this.querySelector('.tinker-time-wrapper')) {
        this.render();
    }

    this.inputDisplay = this.querySelector('.tinker-time-display');
    this.hiddenInput = this.querySelector('input[type="hidden"]');
    this.popup = this.querySelector('.tinker-time-popup');

    if (this.initialValue && this.inputDisplay) {
      this.inputDisplay.value = this.initialValue;
      this.hiddenInput.value = this.initialValue;
    }

    if(this.inputDisplay) {
        // Replace node to ensure clean event listeners
        const newDisplay = this.inputDisplay.cloneNode(true);
        this.inputDisplay.parentNode.replaceChild(newDisplay, this.inputDisplay);
        this.inputDisplay = newDisplay;
        this.inputDisplay.addEventListener('click', (e) => { e.stopPropagation(); this.toggle(); });
    }
    
    document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });
  }

  observeChanges() {
    this.observer = new MutationObserver((mutations) => {
        // If the wrapper is gone, the theme wiped us. Re-init.
        if (!this.querySelector('.tinker-time-wrapper')) {
            this.init();
        }
    });
    this.observer.observe(this, { childList: true });
  }

  injectStyles() {
    if (document.getElementById('tinker-time-styles')) return;
    const style = document.createElement('style');
    style.id = 'tinker-time-styles';
    style.textContent = `
      .tinker-time-wrapper { position: relative; width: 100%; }
      .tinker-time-display {
        width: 100%; padding: 12px 16px; border: 1px solid rgba(0,0,0,0.12);
        border-radius: 1.7rem; font-size: 14px; background: #fff; cursor: pointer;
        transition: border-color 0.2s;
      }
      .tinker-time-display:hover { border-color: rgba(0,0,0,0.4); }
      .tinker-time-popup {
        position: absolute; top: 110%; left: 0; width: 280px;
        background: white; border: 1px solid #eee; border-radius: 12px;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1); z-index: 1000; padding: 12px;
        opacity: 0; transform: translateY(-10px); pointer-events: none;
        transition: opacity 0.2s ease, transform 0.2s ease;
      }
      .tinker-time-popup.is-open { opacity: 1; transform: translateY(0); pointer-events: auto; }
      .time-list { display: flex; flex-direction: column; gap: 4px; max-height: 240px; overflow-y: auto; }
      .time-option {
        background: none; border: none; padding: 10px; text-align: left; cursor: pointer;
        border-radius: 8px; font-size: 14px; transition: background 0.1s; color: #333;
      }
      .time-option:hover { background: #f4f4f4; }
    `;
    document.head.appendChild(style);
  }

  toggle() { this._isOpen ? this.close() : this.open(); }
  open() { this._isOpen = true; if(this.popup) this.popup.classList.add('is-open'); }
  close() { this._isOpen = false; if(this.popup) this.popup.classList.remove('is-open'); }

  selectTime(value) {
    if(this.inputDisplay) this.inputDisplay.value = value;
    if(this.hiddenInput) this.hiddenInput.value = value;
    this.close();
    this.dispatchEvent(new Event('change', { bubbles: true }));
  }

  render() {
    const listHtml = this.options.map(opt => 
      `<button type="button" class="time-option" data-value="${opt}">${opt}</button>`
    ).join('');

    // Preserve existing script tag if it exists, otherwise it gets wiped
    const scriptTag = this.querySelector('script');
    const scriptHTML = scriptTag ? scriptTag.outerHTML : '';
    const existingVal = this.value || '';

    this.innerHTML = `
      ${scriptHTML}
      <div class="tinker-time-wrapper">
        <input type="text" class="tinker-time-display" placeholder="Select Time" readonly>
        <input type="hidden" name="${this.name}" value="${existingVal}">
        <div class="tinker-time-popup">
          <div class="time-list">${listHtml}</div>
        </div>
      </div>
    `;

    this.querySelectorAll('.time-option').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectTime(btn.dataset.value);
      });
    });
  }
}
customElements.define('tinker-time', TinkerTime);